import Api from '@/vuex/api'

const api = new Api()

const UserStore = {
  userData: {},
  loggedIn: false,
  administrator: false,
  staff: false,
  client: false,
  contractor: false,
  async refreshUser () {
    let account = {}
    try {
      account = await api.refreshLoggedInUser()
    } catch (err) {
      throw err
    }
    this.userData = account.object
    // Setting the role of user for the frontEnd
    switch (account.object.AccountType.role) {
      case 'Admin':
        this.administrator = true
        this.staff = false
        this.client = false
        this.contractor = false
        break
      case 'Staff':
        this.administrator = false
        this.staff = true
        this.client = false
        this.contractor = false
        break
      case 'Client':
        this.administrator = false
        this.staff = false
        this.client = true
        this.contractor = false
        break
      case 'Contractor':
        this.administrator = false
        this.staff = false
        this.client = false
        this.contractor = true
        break
      default:
        this.administrator = false
        this.staff = false
        this.client = false
        this.contractor = false
        break
    }
    this.loggedIn = true
  },
  logout () {
    this.userData = {}
    this.administrator = false
    this.staff = false
    this.client = false
    this.contractor = false
    this.loggedIn = false
  }
}

const UserPlugin = {
  install (Vue) {
    Vue.mixin({
      data () {
        return {
          userStore: UserStore
        }
      }
    })
    Object.defineProperty(Vue.prototype, '$user', {
      get () {
        return this.$root.userStore
      }
    })
  }
}

export default UserPlugin



// WEBPACK FOOTER //
// ./src/userPlugin.js